var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "321px",
    height: "321px",
    viewBox: "0 0 321 321",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(14.000000, 14.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 30
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212,1 L292,1",
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,1 L292,81",
    id: "Line-2",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,119 L292,292",
    id: "Line-2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,-86 L88,87",
    id: "Line-2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(88.000000, 1.000000) rotate(-90.000000) translate(-88.000000, -1.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.5,151.5 L152.5,431.5",
    id: "Line-2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(152.500000, 292.000000) rotate(-90.000000) translate(-152.500000, -292.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,1 L1,292",
    id: "Line-2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(1.000000, 147.000000) rotate(-0.000000) translate(-1.000000, -147.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,1 L135,158",
    id: "Line-3",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/open-icon.ab9997a4057429c69c38b2e5ef785a0d.svg";
export { ForwardRef as ReactComponent };